export default __webpack_public_path__ + "static/media/WDCM1.17441d62.png";